<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <foot-menus/>
  </div>
</template>

<script>
import router from "./router";
import FootMenus from "@/components/footMenus/footMenus";

export default {
  name: 'App',
  router,
  components: {FootMenus},
}


</script>

<style lang="less">
  @px: 100rem;

  .center_status_pop {
    width: auto!important;
    height: auto!important;
    padding-left: 20/@px;
    padding-right: 20/@px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    line-height: 50/@px;
    border-radius: 10/@px;
    font-size: 16/@px;
    font-weight: 400;
    color: white;
    background: rgba(0, 0, 0, .8);

    z-index: 999;
  }
</style>
